import * as React from 'react';
import {FlatList, ListRenderItemInfo} from 'react-native';

import OfferListItem from './OfferListItem';

import ListItemNormalSeparator from '../../../shared/lists/separators/ListItemNormalSeparator';

import Offer from '../../../../../domain/entities/writers_gate/Offer';

interface Props {
  offers: Offer[];
  wrriterUserId: number;
  ListFooterComponent?:
    | React.ComponentType<any>
    | React.ReactElement
    | null
    | undefined;
  onForceUpdate: () => void;
}

const OfferList: React.FC<Props> = props => {
  const {offers, wrriterUserId, ListFooterComponent, onForceUpdate} = props;
  const renderItem = React.useCallback(
    (info: ListRenderItemInfo<Offer>) => (
      <OfferListItem
        offer={info.item}
        wrriterUserId={wrriterUserId}
        onForceUpdate={onForceUpdate}
      />
    ),
    [],
  );
  return (
    <FlatList
      data={offers}
      style={{backgroundColor: '#fafafa'}}
      renderItem={renderItem}
      ListHeaderComponent={ListItemNormalSeparator}
      ListFooterComponent={
        <>
          <ListItemNormalSeparator />
          {ListFooterComponent}
        </>
      }
      ItemSeparatorComponent={ListItemNormalSeparator}
    />
  );
};

export default React.memo(OfferList);
